export default "<div class=\"rich-text-holder\" [innerHTML]=\"transformYourHtml()\"></div>\n";